import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Tooltip, Text, Button, Box } from '@wix/design-system';
import { useIsMobile } from '@wix/core-domain-search';
import { ModalsModule } from '../../module/extensions/ModalsExtensions';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
export const MobileAwareDisabledExplainer = _ref => {
  let children = _ref.children,
    content = _ref.content,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    tooltipProps = _ref.tooltipProps,
    dataHook = _ref.dataHook;
  const isMobile = useIsMobile();
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  const openInfoModal = () => {
    const infoModal = ModalsModule.internals.domainsSharedModalsController.infoModal;
    infoModal.show({
      content: /*#__PURE__*/React.createElement(Box, {
        direction: "vertical"
      }, /*#__PURE__*/React.createElement(Box, {
        paddingTop: "SP1"
      }, typeof content === 'string' ? /*#__PURE__*/React.createElement(Text, {
        weight: "thin"
      }, content) : content), /*#__PURE__*/React.createElement(Box, {
        align: "right",
        paddingTop: "SP6"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: () => infoModal.hide()
      }, t('domain_search_suite.results.error.modal.cta.gotIt'))))
    });
  };
  if (!isMobile) {
    return /*#__PURE__*/React.createElement(Tooltip, _extends({
      maxWidth: "280px"
    }, tooltipProps, {
      disabled: !disabled,
      content: content
    }), children);
  }
  if (!disabled) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook,
    onClick: openInfoModal,
    style: {
      display: 'inline-block',
      cursor: 'pointer'
    }
  }, children);
};
//# sourceMappingURL=MobileAwareDisabledExplainer.js.map